const Flag = require('./Flag');

function Flags(flags) {
  return Object.keys(flags).reduce((acc, flag) => {
    acc[flag] = new Flag(flag, flags[flag]);
    return acc;
  }, {});
}

module.exports = Flags;
